import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const materialsSearch = listSearch.extend({
  category: z.string().optional(),
});

export const Route = createFileRoute("/app/admin/materials/")({
  validateSearch: materialsSearch,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
